import { useMutation } from '@tanstack/react-query';
import { quizService } from '@/query/services/quizService';

export const useCompleteQuiz = () => {
  return useMutation({
    mutationFn: ({ slug, anonymousId }) =>
      quizService
        .complete(slug, { anonymous_id: anonymousId })
        .then(response => {
          const { status, data } = response;
          if (status === 200 || status === 201) {
            return data;
          }
          const error = new Error('Quiz completion failed');
          error.response = { status };
          throw error;
        }),
    retry: (failureCount, error) =>
      (!error?.response?.status || error.response.status >= 500) &&
      failureCount < 1,
  });
};
